module.exports = __webpack_public_path__ + "img/banner5.12ffec16.jpg";